import React from 'react';
import {Box, IconButton} from '@mui/material';
import {Add} from '@mui/icons-material';
import {t} from '../../themes/statamicTokens';

const SavedViewsTabs = ({views = [], activeId, onSelect, onAdd}) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            px: 3,
            borderBottom: `1px solid ${t.color.border.default}`,
        }}
    >
        {views.map(v => {
            const active = v.id === activeId;
            return (
                <Box
                    key={v.id}
                    onClick={() => onSelect?.(v.id)}
                    sx={{
                        px: 1.5,
                        py: 1.25,
                        cursor: 'pointer',
                        fontSize: `${t.type.small.size}px`,
                        fontWeight: active ? 600 : 500,
                        color: active ? t.color.accent.primary : t.color.text.secondary,
                        borderBottom: active
                            ? `2px solid ${t.color.accent.primary}`
                            : '2px solid transparent',
                        marginBottom: '-1px',
                        transition: 'color 120ms ease',
                        '&:hover': { color: t.color.text.primary },
                    }}
                >
                    {v.label}
                </Box>
            );
        })}
        {onAdd && (
            <IconButton
                size="small"
                onClick={onAdd}
                sx={{
                    ml: 0.5,
                    color: t.color.text.muted,
                    '&:hover': { color: t.color.text.primary, backgroundColor: t.color.sidebarHover },
                }}
            >
                <Add fontSize="small"/>
            </IconButton>
        )}
    </Box>
);

export default SavedViewsTabs;
